import { DuplicateResolutionStudentRegions } from './duplicate-resolution-student-regions';
import { Student } from 'src/app/model/student/student.model';
import { DuplicateResolutionStudentProperties } from './duplicate-resolution-student-properties';

export class DuplicateResolutionStudents {
    ID: number;
    DUPLICATE_RESOLUTIONS_ID: number;
    STUDENTS_ID: number;
    STUDENT: Student;
    DUPLICATE_RESOLUTION_STUDENT_PROPERTIES: DuplicateResolutionStudentProperties[];
    DUPLICATE_RESOLUTION_STUDENT_REGIONS: DuplicateResolutionStudentRegions[];
}

export class DuplicateResolutionFlatCompareStudents {
    ID: number;
    DUPLICATE_RESOLUTIONS_ID: number;
    STUDENTS_ID: number;
    STUDENT: Student;
}
